module.exports = __webpack_public_path__ + "img/products-4.9dc62aac.png";